"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableColumn = function (props) { return null; };
TableColumn.defaultProps = {
    sortable: false,
    truncate: false
};
exports.default = TableColumn;
//# sourceMappingURL=table-column.js.map